import { Directive, HostListener } from '@angular/core';

/**
 * Formats a phone input as the dashed `555-123-4567` US format as the user
 * types.
 *
 * Two bugs fixed (#1287):
 *  1. The previous mask wrote `(555)-123-4567` which did NOT match the form's
 *     `Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)`, so a correctly-typed number
 *     was rejected. The mask now emits the dashed format the validator expects.
 *  2. The mask only mutated `input.value` (the DOM) and never told Angular, so
 *     the FormControl kept the raw keystrokes and the pattern validator ran
 *     against an unmasked value. We now dispatch a synthetic `input` event so
 *     the reactive FormControl reads the masked value.
 */
@Directive({
  standalone: true,
  selector: '[abxPhoneMask]',
})
export class PhoneMaskDirective {
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    // Ignore the synthetic event we dispatch below to avoid recursing.
    if (!event.isTrusted) {
      return;
    }

    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(/\D+/g, '').slice(0, 10);
    const match = cleaned.match(/^(\d{1,3})(\d{1,3})?(\d{1,4})?$/);

    const formatted = match ? `${match[1]}${match[2] ? '-' + match[2] : ''}${match[3] ? '-' + match[3] : ''}` : '';

    if (input.value !== formatted) {
      input.value = formatted;
      // Tell Angular's reactive forms the value changed so the FormControl (and
      // its pattern validator) sees the masked, dashed value — not the raw
      // keystrokes (#1287).
      input.dispatchEvent(new Event('input', { bubbles: false }));
    }
  }
}
